import { schema } from 'normalizr';

const notificationSchema = new schema.Entity('notifications', {
  //
});

export default notificationSchema;
